import { effects } from 'redux-saga'

import {
  LOAD_SERVICES,
  LOAD_SERVICES_IP,
  LOAD_SERVICES_CLIENT,
} from '../../modules/service/reducer'

import changePassword from './changePassword'
import load from './load'
import loadIp from './loadIp'
import loadClient from './loadClient'

export default function* service({ invocation }) {
  yield [
    effects.call(changePassword, invocation),
    effects.takeEvery(LOAD_SERVICES, load, invocation),
    effects.takeEvery(LOAD_SERVICES_CLIENT, loadClient, invocation),
    effects.takeEvery(LOAD_SERVICES_IP, loadIp, invocation),
  ]
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/sagas/service/index.js